import { useState, useRef, useCallback } from "react";

export default function BeforeAfterSlider({ before, after, label }) {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const updatePos = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  }, []);

  const onMouseDown = () => { dragging.current = true; };
  const onMouseUp = () => { dragging.current = false; };
  const onMouseMove = (e) => { if (dragging.current) updatePos(e.clientX); };
  const onTouchMove = (e) => { updatePos(e.touches[0].clientX); };

  return (
    <div style={{ marginBottom: '12px' }}>
      <div ref={containerRef} data-testid="before-after-slider"
        onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseLeave={onMouseUp}
        onMouseMove={onMouseMove} onTouchMove={onTouchMove} onTouchStart={onMouseDown} onTouchEnd={onMouseUp}
        onClick={(e) => updatePos(e.clientX)}
        style={{ position: 'relative', width: '100%', aspectRatio: '4/3', overflow: 'hidden', borderRadius: '12px', cursor: 'col-resize', userSelect: 'none', border: '1px solid #e8e8e8' }}>
        {/* After (full background) */}
        <img src={after} alt="Après" loading="lazy" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} draggable="false" />
        {/* Before (clipped) */}
        <div style={{ position: 'absolute', inset: 0, width: `${pos}%`, overflow: 'hidden' }}>
          <img src={before} alt="Avant" loading="lazy" style={{ width: containerRef.current?.offsetWidth || '100%', height: '100%', objectFit: 'cover', maxWidth: 'none' }} draggable="false" />
        </div>
        {/* Slider line */}
        <div style={{ position: 'absolute', top: 0, bottom: 0, left: `${pos}%`, width: '3px', backgroundColor: '#8B0000', transform: 'translateX(-50%)', zIndex: 2 }}>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#8B0000', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M6 4L2 9L6 14" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 4L16 9L12 14" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
        </div>
        {/* Labels */}
        <span style={{ position: 'absolute', top: '12px', left: '12px', backgroundColor: 'rgba(0,0,0,0.7)', color: '#fff', fontSize: '11px', fontWeight: 700, padding: '4px 10px', borderRadius: '4px', textTransform: 'uppercase', letterSpacing: '0.05em', zIndex: 1 }}>Avant</span>
        <span style={{ position: 'absolute', top: '12px', right: '12px', backgroundColor: 'rgba(139,0,0,0.85)', color: '#fff', fontSize: '11px', fontWeight: 700, padding: '4px 10px', borderRadius: '4px', textTransform: 'uppercase', letterSpacing: '0.05em', zIndex: 1 }}>Après</span>
      </div>
      {label && <p style={{ textAlign: 'center', color: '#666', fontSize: '14px', fontWeight: 600, marginTop: '8px' }}>{label}</p>}
    </div>
  );
}
